<template>
  <div class="content-table">
    <label class="item-name">{{component.name}}</label>
    <div class="grid-wrapper" :style="style">
      <div class="item" v-for="index in getDivNumber" :key="index">
        <template v-if="getComponent(index)">
          <span v-show="getComponent(index).properties.required" class="required">*</span>
          <component
            :is="getComponent(index).componentType"
            :component="getComponent(index)"
            ref="children"
            @input="updateChildValue"
            :value="getComponetnValue(getComponent(index), 0)"
            :index="0">
          </component>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {componentMixin, containerMixin} from './mixins'
import RcInput from './rc-input.vue'
import RcNumeric from './rc-numeric.vue'
import RcLabel from './rc-label.vue'
import RcIdCard from './rc-id-card.vue'
import RcChildrenInput from './rc-children-input.vue'
import RcHyperlink from './rc-hyperlink.vue'
import RcCombobox from './rc-combobox.vue'
import RcDate from './rc-date.vue'

export default {
  name: 'rc-content-table',
  props: ['component'],
  mixins: [componentMixin, containerMixin],
  data () {
    let style = this.getStyle()
    return {
      numberOfColumns: parseInt(this.component.properties.numberOfColumns),
      style: style
    }
  },
  components: {
    RcInput,
    RcNumeric,
    RcLabel,
    RcIdCard,
    RcHyperlink,
    RcCombobox,
    RcChildrenInput,
    RcDate
  },
  methods: {
    initComponent () {
      this.$refs.children.map(m => m.init())
    },
    getStyle () {
      let columns = ''
      if (parseInt(this.component.properties.numberOfColumns) <= 4) {
        let width = 100 / parseInt(this.component.properties.numberOfColumns)
        columns = `repeat(${parseInt(this.component.properties.numberOfColumns)}, ${width}%)`
      } else {
        columns = `repeat(${parseInt(this.component.properties.numberOfColumns)}, 25%)`
      }
      let rows = `repeat(${parseInt(this.component.properties.numberOfLines)}, 62px)`
      return {
        'grid-template-columns': columns,
        'grid-template-rows': rows
      }
    },
    getComponent (index) {
      return this.component.children.find(m => {
        return (parseInt(m.position.row) - 1) * this.numberOfColumns + parseInt(m.position.col) === index
      })
    }
  },
  computed: {
    getDivNumber () {
      return parseInt(this.component.properties.numberOfColumns) * parseInt(this.component.properties.numberOfLines)
    }
  }
}
</script>

<style lang="scss">
  .content-table {
    width: 100%;
    height: 75%;
    .grid-wrapper {
      overflow-x: scroll;
      display: grid;
      grid-gap: 0px;
      > div.item {
        // XXX: 如果有人对框线过粗提出异议, 拿刀
        border: 1px solid #c2c3c4;
        border-radius: 4px;
        background-color: #ffffff;

        .el-form-item {
          .el-form-item__content {
            >div {
              height: 100%;
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
            }
          }
          width: 100%;
          height: 100%;
          margin-bottom: 0px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-content-table.vue